import { type TranslationTree } from '@/i18n/types';

export const messages = {
  category: {
    events: 'Organizador de eventos',
    running_club: 'Assessoria ou grupo de corrida',
    bike_fit: 'Bike fit',
    nutrition: 'Nutrição',
    physio: 'Fisioterapia',
    gear: 'Loja ou marca esportiva',
    sports_media: 'Fotografia esportiva',
    notListed: 'Outro',
  },
} satisfies TranslationTree;
